/**
 * Passage du sujet saisi dans le chat vers l'atelier de corrigés.
 *
 * Par le stockage de session plutôt que par l'adresse : un énoncé de cas
 * pratique peut faire plusieurs milliers de caractères, et la navigation du
 * site réécrit les paramètres d'adresse.
 */
import type { TypeExercice } from "../../../supabase/functions/_shared/exercices/types";

const CLE = "jurivia:atelier:sujet";

export function transmettreSujet(type: TypeExercice, sujet: string): void {
  try {
    if (sujet.trim()) sessionStorage.setItem(CLE, JSON.stringify({ type, sujet: sujet.slice(0, 80_000) }));
    else sessionStorage.removeItem(CLE);
  } catch {
    /* stockage indisponible (navigation privée) : l'étudiant ressaisit le sujet */
  }
}

/** Sujet transmis pour ce type d'exercice, lu une seule fois. */
export function reprendreSujet(type: TypeExercice): string | undefined {
  try {
    const brut = sessionStorage.getItem(CLE);
    if (!brut) return undefined;
    sessionStorage.removeItem(CLE);
    const v = JSON.parse(brut) as { type?: string; sujet?: string };
    return v.type === type && typeof v.sujet === "string" ? v.sujet : undefined;
  } catch {
    return undefined;
  }
}
